import { render, staticRenderFns } from "./Centro_costo.vue?vue&type=template&id=d52940cc"
import script from "./Centro_costo.vue?vue&type=script&lang=js"
export * from "./Centro_costo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports